import { css, styled } from "@mui/material";

const common = css`
  padding: 0px 4px;
  border-radius: 4px;
  font-family: "Roboto Mono", monospace;
  font-size: 14px;
  word-break: break-all;
`;

export const CodeContainer = styled("pre")(
  ({ theme }) => css`
    margin: 16px 16px;
    padding: 12px;
    border-radius: 8px;
    overflow: auto;

    background: ${theme.palette.mode === "dark" ? "#282c34" : "#f0f0f0"};

    ${theme.breakpoints.up("mobile")} {
      margin: 16px 16px;
    }

    ${theme.breakpoints.up("tablet")} {
      margin: 16px 32px;
    }

    ${theme.breakpoints.up("desktop")} {
      margin: 16px 64px;
    }

    code {
      display: inline-table;
    }
  `,
);

export const CodeStyled = styled("code")(({ theme }) =>
  theme.palette.mode === "dark"
    ? css`
        ${common}
        color: #abb2bf;
        background: #282c34;

        .hljs-comment,
        .hljs-quote {
          color: #5c6370;
          font-style: italic;
        }

        .hljs-doctag,
        .hljs-keyword,
        .hljs-formula {
          color: #c678dd;
        }

        .hljs-section,
        .hljs-name,
        .hljs-selector-tag,
        .hljs-deletion,
        .hljs-subst {
          color: #e06c75;
        }

        .hljs-literal {
          color: #56b6c2;
        }

        .hljs-string,
        .hljs-regexp,
        .hljs-addition,
        .hljs-attribute,
        .hljs-meta .hljs-string {
          color: #98c379;
        }

        .hljs-attr,
        .hljs-variable,
        .hljs-template-variable,
        .hljs-type,
        .hljs-selector-class,
        .hljs-selector-attr,
        .hljs-selector-pseudo,
        .hljs-number {
          color: #d19a66;
        }

        .hljs-symbol,
        .hljs-bullet,
        .hljs-link,
        .hljs-meta,
        .hljs-selector-id,
        .hljs-title {
          color: #61aeee;
        }

        .hljs-built_in,
        .hljs-title.class_,
        .hljs-class .hljs-title {
          color: #e6c07b;
        }

        .hljs-emphasis {
          font-style: italic;
        }

        .hljs-strong {
          font-weight: bold;
        }

        .hljs-link {
          text-decoration: underline;
        }
      `
    : css`
        ${common}
        color: #383a42;
        background: #f0f0f0;

        .hljs-comment,
        .hljs-quote {
          color: #a0a1a7;
          font-style: italic;
        }

        .hljs-doctag,
        .hljs-keyword,
        .hljs-formula {
          color: #a626a4;
        }

        .hljs-section,
        .hljs-name,
        .hljs-selector-tag,
        .hljs-deletion,
        .hljs-subst {
          color: #e45649;
        }

        .hljs-literal {
          color: #0184bb;
        }

        .hljs-string,
        .hljs-regexp,
        .hljs-addition,
        .hljs-attribute,
        .hljs-meta .hljs-string {
          color: #50a14f;
        }

        .hljs-attr,
        .hljs-variable,
        .hljs-template-variable,
        .hljs-type,
        .hljs-selector-class,
        .hljs-selector-attr,
        .hljs-selector-pseudo,
        .hljs-number {
          color: #986801;
        }

        .hljs-symbol,
        .hljs-bullet,
        .hljs-link,
        .hljs-meta,
        .hljs-selector-id,
        .hljs-title {
          color: #4078f2;
        }

        .hljs-built_in,
        .hljs-title.class_,
        .hljs-class .hljs-title {
          color: #c18401;
        }

        .hljs-emphasis {
          font-style: italic;
        }

        .hljs-strong {
          font-weight: bold;
        }

        .hljs-link {
          text-decoration: underline;
        }
      `,
);
